import Router from "./users-router";

import UsersComponent from "./users-component";


const Module = angular
    .module("app.users", [])
    .component("users", UsersComponent)
    .config(Router);

export default Module;


// WEBPACK FOOTER //
// ./sources/components/users/users-module.js